import { createApi, OrderState } from '@quotetome/materials-api'
import orderStatesExtension from '@/models/order-states-extension'
import { axiosInstance } from '~/plugins/axios'

OrderState.extendStates(orderStatesExtension)

export const api = createApi(axiosInstance, () => '', { useCookieAuth: true })

export default defineNuxtPlugin(() => {
  return {
    provide: { api }
  }
})
